import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classNames from "classnames";

import styles from "./Toggle.module.scss";

export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
} & Omit<SafeHtmlAttributes<HTMLButtonElement>, "onChange">;

export const Toggle = ({ checked, onChange, disabled, ...rest }: ToggleProps) => (
  <button
    {...rest}
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={styles.toggle}
  >
    <span className={classNames(styles.track, { [styles.trackChecked]: checked })}>
      <span className={styles.dot} />
    </span>
  </button>
);
